<template>
  <SbsMainLayout>
    <SubscriptionContent />
  </SbsMainLayout>
</template>

<script lang="ts" setup>
import SbsMainLayout from '@/components/snowflake/SbsMainLayout.component.vue';
import SubscriptionContent from '@/components/SubscriptionContent.component.vue';
</script>
